const x = {
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
  "2xl": "1536px"
};
export {
  x as breakpoints
};
//# sourceMappingURL=breakpoints.es.js.map
